// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"211":"252eacb3","215":"b32dc8f9"}[chunkId] + ".chunk.css");